/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min_length: NonNullable<unknown> }} Error_Zns_Param_Below_Min_LengthInputs */

const vi_error_zns_param_below_min_length = /** @type {(inputs: Error_Zns_Param_Below_Min_LengthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giá trị cố định ngắn hơn ${i?.min_length} ký tự mẫu yêu cầu.`)
};

/**

* @param {Error_Zns_Param_Below_Min_LengthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_param_below_min_length = /** @type {((inputs: Error_Zns_Param_Below_Min_LengthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Param_Below_Min_LengthInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_param_below_min_length(inputs)
});